export default __webpack_public_path__ + "cfa40e7698347d97b49acd4598c682e8.png";